import styled from '@emotion/styled';

const ControlsWrapper = styled('div')({
  marginTop: 12,
  display: 'flex',
  alignItems: 'flex-start',
});

export default ControlsWrapper;
